import React, { ReactElement } from 'react';
import { Link } from 'idsk-react-components';
import { useParams } from 'react-router';
import add from '../icons/add.svg';
import routes from '../../../routing/routes';
import { useUserContext } from '../../../context/UserContext';
import { canSendOrAdd } from '../../../function/permissions';
import Secured from '../../Secured';
import UserRole from '../../../model/currentuser/UserRole';

interface Props {
  setOpenDropdown: (isOpen: boolean) => void;
}

const AddPripomienkaButton = ({ setOpenDropdown }: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const { pouzivatel, legislationProcess } = useUserContext();

  return (
    <Secured
      allowForRoles={[UserRole.NELEGISLATIVNA_ORGANIZACIA, UserRole.VEREJNOST, UserRole.PRIPOMIENKOVATEL]}
      additionalCheck={canSendOrAdd(pouzivatel, legislationProcess)}
    >
      <li key="Pridať pripomienku" className="action-item">
        <div className="icon-wrapper">
          <img src={add} className="icon" alt="Pridať pripomienku" />
        </div>
        <Link
          onClick={() => setOpenDropdown(false)}
          to={routes.pripomienky.add.withParams(type, year, index)}
          className="button-inline-text"
        >Pridať pripomienku
        </Link>
      </li>
    </Secured>
  );
};

export default AddPripomienkaButton;
